/**
 * 
 * key
 * 
 */


const key = 'dGlja2V0U3VtbWFyeQ=='

export default key 